import type { MouseEvent } from "react";
const DEFAULT_COOKIE_POLICY_FALLBACK = "/cookie-policy";
export function openPrivacyManager(event: MouseEvent<HTMLAnchorElement>, fallbackUrl: string = DEFAULT_COOKIE_POLICY_FALLBACK): void {
  event.preventDefault();
  // SourcePoint exposes only the campaign that applies to the visitor's region:
  // GDPR in the EU/UK, CCPA in the US.
  const campaign = window._sp_?.gdpr ?? window._sp_?.ccpa;
  if (campaign) {
    try {
      campaign.loadPrivacyManagerModal();
      return;
    } catch {
      // CMP present but the modal failed to open — fall through to the policy page.
    }
  }
  // CMP unavailable (failed to load, or non-production): navigate to the cookie
  // policy rather than silently doing nothing. Matches the bumble-love-stories /
  // bumble-site-rebrand-2024 fallback behaviour. The caller passes a
  // locale-prefixed URL so this lands on a real route.
  window.location.href = fallbackUrl;
}